/*
 * @Author: zhenfangyu 2211267244@qq.com
 * @Date: 2024-05-31 09:52:38
 * @LastEditors: zhenfangyu 2211267244@qq.com
 * @LastEditTime: 2024-06-05 14:07:16
 * @FilePath: \jzt-kf-h5\src\utils\location.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
function parseQuery(query) {
  const res = {}

  query = query.trim().replace(/^(\?|#|&)/, '')

  if (!query) {
    return res
  }

  query.split('&').forEach(param => {
    const decode = decodeURIComponent
    const parts = param.replace(/\+/g, ' ').split('=')
    const key = decode(parts.shift())
    const val = parts.length > 0 ? decode(parts.join('=')) : null

    if (res[key] === undefined) {
      res[key] = val
    } else if (Array.isArray(res[key])) {
      res[key].push(val)
    } else {
      res[key] = [res[key], val]
    }
  })

  return res
}

/**
 * 获取hash模式下的query参数
 */
function parseHashQuerys() {
  const query = parseQuery(location.hash.replace(/#.+\?/, '?'))
  return query || {}
}

export { parseQuery, parseHashQuerys }
